import { toast } from 'react-toastify';
import { api } from '../api';
import { HealthParameterThreshold } from '../../entities/HealthParameter';

/**
 * A régua clínica, para o painel "Ver parâmetros".
 *
 * ⚠️ **`includeInactive` é o que traz a aba da gestante.** As linhas gestacionais
 * estão semeadas **inativas** no `cinco-back`, porque `patients` ainda não tem linha
 * de cuidado — o classificador não as aplica a ninguém. Elas existem como referência
 * consultável, e a tela precisa **dizer** que ainda não valem.
 */
export const listThresholds = async (
  includeInactive = false,
): Promise<HealthParameterThreshold[]> => {
  try {
    const { data } = await api.get('/health-parameters', {
      params: { includeInactive: String(includeInactive) },
    });

    return data;
  } catch (error) {
    toast.error('Aconteceu um problema. Entre em contato com o administrador.');

    return [];
  }
};
